/**
 * Product feature flags — flip to re-enable self-serve Agency flows.
 * See docs/internal/AGENCY_SELF_SERVE_PAUSE_TRACKING.md
 */
export const AGENCY_SELF_SERVE_ENABLED = false;
